import styled, { css } from 'styled-components';

import { Container } from '@/components/Container';
import { Flex } from '@/components/Flex';
import { theme } from '@/theme';

import type { ListingFiltersType } from './ListingFiltersProviderContext';
import type { ListingFiltersVariant } from './types';

export const FiltersWrapper = styled.div<{
  shouldUpdateVariant: boolean;
  top: number;
  variant: ListingFiltersVariant;
}>`
  isolation: isolate;
  position: sticky;

  ${({ shouldUpdateVariant, theme, top, variant }) => css`
    background: ${variant === 'default'
      ? theme.colors.white
      : theme.colors.transparent};
    z-index: ${theme.zIndex.sortingDropdown};
    top: ${top}px;
    margin-top: ${shouldUpdateVariant ? `-${theme.spacing(8)}` : 'initial'};
  `};

  ${theme.media.md.up} {
    overflow: initial;
  }
`;

export const RelativeContainer = styled(Container)<{
  $type: ListingFiltersType;
}>`
  position: relative;
  ${theme.media.md.up} {
    overflow: initial;
  }
  ${({ $type }) =>
    $type === 'SEARCH_VIEW' &&
    css`
      padding: 0;
    `}
`;

export const Wrapper = styled(Flex)`
  padding: ${({ theme }) => theme.spacing(2, 0)};
  flex-flow: column;

  ${theme.media.sm.up} {
    flex-flow: row-reverse;
  }
`;

export const FiltersColumn = styled(Flex)<{ $hidden?: boolean }>`
  width: 100%;
  font-size: ${({ theme }) => theme.fontSizes.p2};

  ${theme.media.md.up} {
    width: max-content;
  }
  ${({ $hidden }) =>
    $hidden &&
    css`
      display: none;
    `}
`;

export const Filters = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: space-between;

  ${theme.media.md.up} {
    justify-content: flex-start;
    width: auto;
  }
`;

export const Label = styled.span<{ variant: ListingFiltersVariant }>`
  display: none;

  ${theme.media.lg.up} {
    ${({ variant }) =>
      variant === 'defaultInverted' &&
      css`
        color: ${theme.colors.white};
      `};

    display: block;
  }
`;

export const FiltersAppliedList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
